import { takeEvery } from 'redux-saga/effects';
import { consts as uploadDocuments } from '../documents-upload-req';
import { consts as deleteDocuments } from '../documents-delete-req';
import { handleServerErrorWithToast } from '../../../utils/ui/handleServerErrorsWithToast';

export function* handleDependentDocumentsErrorsSaga() {
  yield takeEvery(
    [
      uploadDocuments.REJECTED,
      uploadDocuments.ERROR_ENCOUNTERED,
      deleteDocuments.REJECTED,
      deleteDocuments.ERROR_ENCOUNTERED,
    ],
    handleServerErrorWithToast,
  );
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/handle-documents-error-saga.js